import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanDestType } from 'src/bean/BeanDestType';
import { BeanDestinatarios } from 'src/bean/BeanDestinatarios';
import { environment } from 'src/environments/environment';
import { BeanOperacao } from '../../../bean/BeanOperacao';


@Injectable()

export class CadastroOperacaoervice {

  constructor(
      private http: HttpClient
  ){ }



  addOperacao(formModel: BeanOperacao):Promise<any>{
    return this.gravarOperacao(formModel).toPromise().then((resposta:any) => resposta);
  }

  public gravarOperacao(formModel: BeanOperacao):Observable<any> {

      const tokenString = localStorage.getItem('access_token');

      let json = JSON.stringify(formModel);

      const headers = {
          'Authorization' : 'Bearer ' + tokenString,
          'Content-Type' : 'application/json'
      }

      return this.http.post(environment.urlBackend +  environment.criarOperacao, json, {headers: headers});
  }



  updateOperacao(formModel: BeanOperacao):Promise<any>{
      return this.atualizarOperacao(formModel).toPromise().then((resposta:any) => resposta);
  }

  public atualizarOperacao(formModel: BeanOperacao):Observable<any> {
      const tokenString = localStorage.getItem('access_token');

      let json = JSON.stringify(formModel);

      const headers = {
          'Authorization' : 'Bearer ' + tokenString,
          'Content-Type' : 'application/json'
      }

      return this.http.put(environment.urlBackend + environment.updateOperacao + "/" +formModel.operIdCdOperacao +"/",  json, { headers : headers});

  }

  public listarCadastroOperacoes(str : string):Promise<any>{

      const tokenString = localStorage.getItem('access_token');

      const headers = {
          'Authorization' : 'Bearer ' + tokenString,
          'Content-Type': 'application/json'
          };

      return this.http.get(environment.urlBackend +  environment.listarCadastroOperacoes, {headers}).toPromise().then((resposta:BeanOperacao[]) => resposta)

  }

  saveDestinatario(formModel: BeanDestinatarios):Promise<any>{
      return this.criarDestinatario(formModel).toPromise().then((resposta:any) => resposta);
  }

  public criarDestinatario(formModel: BeanDestinatarios):Observable<any> {
      const tokenString = localStorage.getItem('access_token');


      let json = JSON.stringify(formModel);

      const headers = {
          'Authorization' : 'Bearer ' + tokenString,
          'Content-Type' : 'application/json'
      }

      return this.http.post(environment.urlBackend + environment.saveDestinatario,  json, { headers : headers});

  }

  public atualizaDestinatario(formModel: BeanDestinatarios) {
    const tokenString = localStorage.getItem('access_token');


    let json = JSON.stringify(formModel);

    const headers = {
        'Authorization' : 'Bearer ' + tokenString,
        'Content-Type' : 'application/json'
    }

    return this.http.put(environment.urlBackend + environment.atualizaDestinatario + formModel.idDeopCdDestoper,  json, { headers : headers});
  }

  public listarDestType():Promise<any>{

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization' : 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return this.http.get(environment.urlBackend +  environment.getAllActive, {headers}).toPromise().then((resposta:BeanDestType[]) => resposta)
  }

}
